import type { CADViewManager } from '@/plugins/cad/module/CADModule/manager/CADViewManager'
import type { IEntity } from '@/plugins/cad/module/CADModule/model/entity'
import { Command } from '@/plugins/cad/module/core/Command'

/**
 * 合并实体命令，以合并结果替换原实体并支持撤销。
 */
export class JoinEntityCommand extends Command {
  constructor(
    private addEntities: IEntity[],
    private deleteEntities: IEntity[],
    private viewManager: CADViewManager
  ) {
    super()
  }

  /** 加入合并结果并移除原实体 */
  execute(): void {
    this.viewManager.addEntities(this.addEntities)
    this.viewManager.deleteEntities(this.deleteEntities)
  }

  /** 撤销：移除合并结果并恢复原实体 */
  undo(): void {
    this.viewManager.deleteEntities(this.addEntities)
    this.viewManager.addEntities(this.deleteEntities)
  }
}
